import React, { useMemo } from 'react';
import JoinChallengeButton from '../../Components/JoinChallengeButton/JoinChallengeButton';
import './style.css';
import { useGetWithAxios } from '../../Hooks/useGetWithAxios';
import { useWindowDimensions } from '../../Hooks/useWindowDimensions';
const MissionInformation = (props) => {
    const { lang, missionId, conqFlagImage = '' } = props;
    const { data } = useGetWithAxios('/appv2/share-page/mission-information', {
        params: {
            mission_id: missionId,
            lang: lang,
        },
        enabled: !!(missionId && lang),
    });
    const { width: screenWidth } = useWindowDimensions();
    const isMobile = useMemo(() => screenWidth <= 834, [screenWidth]);
    if (!data) {
        return null;
    }
    const { missionDetails, whyFinishSection, footer, ctaButton, featured, privacy, missionColor, missionName, checkIcon, eventUrl, } = data;
    return (React.createElement("div", { className: 'mission-info' },
        React.createElement("div", { className: 'white-background' },
            React.createElement("div", { className: 'container' },
                conqFlagImage !== '' && React.createElement("img", { src: conqFlagImage, className: 'conq-flag' }),
                React.createElement("div", { className: 'mission-details' },
                    React.createElement("div", null,
                        React.createElement("h3", null, missionDetails.heading1.toUpperCase()),
                        React.createElement("h2", { dangerouslySetInnerHTML: {
                                __html: missionDetails.heading2.replace('{mission_name}', `<span style="color: ${missionColor}">${missionName}</span>`),
                            } }),
                        React.createElement("p", { className: 'subheading' }, missionDetails.participantCount),
                        missionDetails.points.map((point, index) => (React.createElement("div", { className: 'list-item', key: index },
                            React.createElement("svg", { className: 'bi', fill: 'currentColor', style: {
                                    color: missionColor,
                                } },
                                React.createElement("use", { xlinkHref: checkIcon })),
                            React.createElement("p", null, point)))),
                        React.createElement("div", { className: 'join-button-container' },
                            React.createElement(JoinChallengeButton, { url: eventUrl, color: missionColor, text: ctaButton, className: 'join-button' }))),
                    React.createElement("img", { src: missionDetails.medalImage })))),
        React.createElement("div", { className: 'container featured' },
            React.createElement("div", { className: 'featured-item' },
                React.createElement("p", null, featured.text.toUpperCase())),
            featured.images.map((imageUrl, index) => (React.createElement("div", { className: 'featured-item', key: index },
                React.createElement("img", { src: imageUrl }))))),
        React.createElement("div", { className: 'white-background' },
            React.createElement("div", { className: 'container why-finish' },
                React.createElement("h3", null,
                    React.createElement("b", null, whyFinishSection.heading)),
                React.createElement("h3", null,
                    "(",
                    whyFinishSection.subHeading,
                    ")"),
                React.createElement("div", { className: 'why-finish-list' }, whyFinishSection.points.map((point, index) => {
                    // Only show top 3 bullet point on mobile
                    if (isMobile && index > 2) {
                        return null;
                    }
                    return (React.createElement("div", { className: 'list-item', key: index },
                        React.createElement("svg", { className: 'bi', fill: 'currentColor', style: {
                                color: missionColor,
                            } },
                            React.createElement("use", { xlinkHref: checkIcon })),
                        React.createElement("p", null, point)));
                })),
                React.createElement("div", { className: 'join-button-container', style: { margin: 0 } },
                    React.createElement(JoinChallengeButton, { url: eventUrl, color: missionColor, text: ctaButton, className: 'join-button' })),
                React.createElement("div", { className: 'privacy' },
                    React.createElement("svg", { className: 'bi', fill: 'currentColor' },
                        React.createElement("use", { xlinkHref: privacy.lockIcon })),
                    React.createElement("p", null,
                        React.createElement("b", null, privacy.privacyPolicy),
                        ": ",
                        privacy.secureText)))),
        React.createElement("div", { className: 'footer' },
            React.createElement("div", { className: 'container footer-container' },
                React.createElement("div", { className: 'privacy-links-container' },
                    React.createElement("a", { href: privacy.privacyPolicyUrl, target: '_blank' }, privacy.privacyPolicy),
                    '|',
                    React.createElement("a", { href: privacy.termsAndConditionsUrl, target: '_blank' }, privacy.termsAndConditions)),
                React.createElement("p", { className: 'rights-reserved' }, footer.rightsReserved),
                React.createElement("p", { className: 'trademark' }, footer.trademark)))));
};
export default MissionInformation;
